// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"321":"ac4f85d0","498":"e2c55e02","703":"99ef6aa2"}[chunkId] + ".chunk.js";
};